import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { setModal } from "../../redux/rightModalSlice";
import moment from "moment";

const statusColors = {
    'bozza': 'bg-gray-100 text-gray-700',
    'confermato': 'bg-blue-100 text-blue-700',
    'in_consegna': 'bg-yellow-100 text-yellow-700',
    'consegnato': 'bg-green-100 text-green-700',
};

export default function SupplierOrderLine({ orderData, index }) {
    const dispatch = useDispatch();

    const handleView = () => {
        dispatch(setModal({ mode: 'view', id: orderData.id }));
    };

    const handleEdit = () => {
        dispatch(setModal({ mode: 'edit', id: orderData.id }));
    };

    const statusClass = statusColors[orderData.statusLabel?.toLowerCase()] || 'bg-gray-100 text-gray-700';

    return (
        <div
            className={`w-full flex justify-between items-center rounded-md cursor-pointer hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
            onClick={handleView}
        >
            <div className="px-6 py-4 w-1/6 font-medium">{orderData.code || '-'}</div>
            <div className="px-6 py-4 w-1/5">{orderData.supplierLabel || '-'}</div>
            <div className="px-6 py-4 w-1/6">
                {orderData.supplierOrderDate ? moment(orderData.supplierOrderDate).format('DD/MM/YYYY') : '-'}
            </div>
            <div className="px-6 py-4 w-1/6">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusClass}`}>
                    {orderData.statusLabel || 'Bozza'}
                </span>
            </div>
            <div className="px-6 py-4 w-1/6">
                {orderData.deliveryDate ? moment(orderData.deliveryDate).format('DD/MM/YYYY') : '-'}
            </div>
            <div className="px-6 py-4 w-1/6 flex justify-end gap-2">
                <button
                    className="p-1.5 hover:bg-gray-200 rounded text-gray-600"
                    onClick={(e) => { e.stopPropagation(); handleEdit(); }}
                    title="Modifica"
                >
                    <DynamicIcon iconClass="fa-solid fa-pen text-sm" />
                </button>
                <button
                    className="p-1.5 hover:bg-gray-200 rounded text-gray-600"
                    onClick={(e) => { e.stopPropagation(); handleView(); }}
                    title="Visualizza"
                >
                    <DynamicIcon iconClass="fa-solid fa-eye text-sm" />
                </button>
            </div>
        </div>
    );
}
